import React from 'react';
import Modal from "react-modal";
import * as actionTypes from "@redux/actionTypes";
import { useDispatch, useSelector } from "react-redux";
import ProfileDashboardMenu from './ProfileDashboardMenu';
import { CloseProfileModelIcon } from '@util/svgicon';
import NftMinting from '@components/NftMinting';
import PurchaseTimeCredit from '@components/Modal/PurchaseTimeCredit';

const ProfileModel = ({ closeProfileModelHandler, setSelectedOption }) => {
    const dispatch = useDispatch();
    const isBuyTcOpen = useSelector((state) => state.buyTc.buyTc);
    const isBuyNft = useSelector((state) => state.buyTc.isBuyNft);

    const closeTcPop = () => {
        dispatch({
            type: actionTypes.BUY_TC,
            payload: false,
        });
    };

    const closeBuyNftModel = () => {
        dispatch({
            type: actionTypes.IS_BUY_NFT,
            payload: false,
        });
    };

    return (
        <div className='flex flex-col gap-[12px] w-full h-full p-[24px]'>
            <div className='min-h-[32px] h-full w-full'>
                <button className='flex pl-[8px] pr-[12px] py-[6px] items-start gap-[6px] rounded-[1000px] border-[1px] border-[solid] border-[#737373] bg-[#FAFAFA]' onClick={closeProfileModelHandler}>
                    <CloseProfileModelIcon />
                    <p className='text-[#000] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Close </p>
                </button>
            </div>
            <div className='w-full h-[calc(100vh-68px)] flex justify-center'>
                <ProfileDashboardMenu
                    setSelectedOption={setSelectedOption}
                    closeProfileModelHandler={closeProfileModelHandler}
                />
            </div>
            <Modal
                isOpen={isBuyTcOpen}
                ariaHideApp={false}
                className="mymodal"
                onRequestClose={closeTcPop}
            >
                <PurchaseTimeCredit />
            </Modal>
            <Modal
                isOpen={isBuyNft}
                ariaHideApp={false}
                className="absolute top-2/4 left-2/4 -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] bg-[#FAFAFA]"
                onRequestClose={closeBuyNftModel}
            >
                <NftMinting />
            </Modal>
        </div>
    )
}

export default ProfileModel